import { styled } from '@mui/material/styles';
const PREFIX = 'SettingsMenu';
export const classes = {
    root: `${PREFIX}-root`,
    list: `${PREFIX}-list`,
    listItem: `${PREFIX}-listItem`,
    listItemIcon: `${PREFIX}-listItemIcon`,
    listItemText: `${PREFIX}-listItemText`,
    listDivider: `${PREFIX}-listDivider`,
    menu: `${PREFIX}-menu`,
    menuList: `${PREFIX}-menuList`,
    paper: `${PREFIX}-paper`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {},
    [`& .${classes.list}`]: {
        flexGrow: 1,
    },
    [`& .${classes.listItem}`]: {
        cursor: 'pointer',
        color: theme.palette.grey[700],
        '&:hover': {
            [`& .${classes.listItemIcon}`]: {
                color: theme.palette.primary.main,
            },
            [`& .${classes.listItemText}`]: {
                color: theme.palette.primary.main,
            },
        },
        '& + &': {
            marginTop: theme.spacing(1),
        },
    },
    [`& .${classes.listItemIcon}`]: {
        color: theme.palette.grey[700],
        minWidth: 24,
    },
    [`& .${classes.listItemText}`]: {
        fontWeight: 500,
        color: theme.palette.grey[700],
        marginLeft: theme.spacing(1),
        height: 24,
        marginTop: 0,
        marginBottom: 0,
    },
    [`& .${classes.listDivider}`]: {
        margin: theme.spacing(1),
    },
    [`& .${classes.menu}`]: {
        position: 'absolute',
        marginLeft: theme.spacing(2),
        zIndex: 99,
    },
    [`& .${classes.menuList}`]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    [`& .${classes.paper}`]: {
        marginRight: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
    },
}));
export default Root;
//# sourceMappingURL=styled.js.map